/**
 * DESERTLAND.Content.Contact
 */
import { Utils } from '../cals.utils';
import { App } from '../desertland.app';
import { ROUTES } from '../desertland.router';
import 'kendo-ui-core';
// import 'kendo-ui-core/js/kendo.layout';

declare var log, info, warn, groupCollapsed, groupEnd;


export class ContactContent {
  public page = ROUTES.CONTACT;
  public container = "#tmpl_main_content";
  public tplSel = 'tpl-layout-contact';

  public init(params = {}) {

    if ($(this.container).length) {
      log("ready for " + this.page);
      this.loadTpl(this.renderTpl);
    } else {
      $(() => {
        log(this.page + " dom ready!");
        if (typeof this.loadTpl === "function" && typeof this.renderTpl === "function") {
          this.loadTpl(this.renderTpl);
        }

      });
    }

  }

  public loadTpl(callback) {
    log(this.page + " > loadTpl");
    if ($(this.tplSel).length) {
      log("// we already have the tpl");
      this.renderTpl({ sel: this.tplSel });
    } else {
      App.templates.loadLayout(this.page, this.tplSel, this.renderTpl);
    }

  }

  public renderTpl = (resp) => {
    $(document).ready(() => {
      log(this.page + " > renderTpl", resp);
  
      if (resp && resp.sel && $(resp.sel).length) {
        //log($(resp.sel));
        let layout = new kendo.Layout($('#'+resp.tag).html(), { model: App.models.pageView.viewModel });
        $(this.container).empty();
        layout.render($(this.container));
  
        Utils.smoothScrollTo('top');
  
        this.addEvents();
  
      } else {
        info("no sel?");
      }   
    });
  }

  public subTplsReady(tags) {
    log('subTplsReady', tags);//ids of script tags
    //tmpl_inject_main_content_nav
    //tmpl_inject_featured_plants
    //var featuredPlants = new kendo.View("<span>Detail - press your browser back button to navigate back.</span>");

  }

  public addEvents() {
    log("contact > addEvents");

    this.addFormSubmitEvent();
  }

  public messageToPage(msg) {
    // Get the messages div.
    let wrap = $('#form_messages');

    if (wrap.length) {
      wrap.html(msg);
    } else {
      info("form_messages el not found?");
    }
  }

  public addFormSubmitEvent() {
    let form = $('#contact_form'),
    showSuccessMessage = this.showSuccessMessage,
    showErrorMessage = this.showErrorMessage;//,
      // me = this;//,
    // formMessages = $('#form_messages');

    if (form.length) {
      // Set up an event listener for the contact form.
      $(form).submit(function (event) {
        // log("form submitted");
        // Stop the browser from submitting the form.
        event.preventDefault();
        // Serialize the form data.
        let formData = $(form).serialize();
        // log('formData:',formData);

        // Submit the form using AJAX.
        $.ajax({
          type: 'POST',
          url: $(form).attr('action'),
          data: formData
        })
          .done(function (response) {
            // info(response);
            let oResp = Utils.tryParseJsonStr(response);
            // Set the message text.
            let result = (oResp && oResp.result) ? oResp.result : "Email sent successfully.";
            if (oResp.errorMsg) {
              //result = response.errorMsg;
              console.warn(oResp.errorMsg);
              showErrorMessage((oResp && oResp.result) ? oResp.result : "Opps! There was a problem sending the email - please try again.");
            } else {
              showSuccessMessage(result);
              // Clear the form.
              $('#sender_name').val('');
              $('#sender_email').val('');
              $('#message_body').val('');
            }
          })
          .fail(function (data) {
            // info(data);
            let oResp = Utils.tryParseJsonStr(data);
            if (oResp && oResp.errorMsg) {
              console.warn(oResp.errorMsg);
            }
            // Set the message text.
            let result = 'Oops! An error occured and your message could not be sent.';
            if (oResp && oResp.result) {
              result = oResp.result;
            } else if (data.responseText !== '') {
              result = data.responseText;
            }
            showErrorMessage(result);
          });
      });

    } else {
      info("form not found?");
    }
  }


  public showSuccessMessage(msg) {
    let formMessages = $('#form_messages');
    if (formMessages.length) {
      // Make sure that the formMessages div has the 'success' class.
      formMessages.removeClass('error bg-danger');
      formMessages.addClass('success bg-success');

      // Set the message text.
      formMessages.text(msg);
    } else {
      info("form_messages el not found?");
    }
  }
  public showErrorMessage(msg) {
    let formMessages = $('#form_messages');
    if (formMessages.length) {
      // Make sure that the formMessages div has the 'error' class.
      formMessages.removeClass('success bg-success');
      formMessages.addClass('error bg-danger');

      // Set the message text.
      formMessages.text(msg);
    } else {
      info("form_messages el not found?");
    }
  }



}
